export { getIsQA } from 'pricing-pages-ui-components/utils/envUtils';

/**
 * Returns true when running inside a Selenium acceptance-test session.
 * Copied from pricing-pages-ui/utils/testUtils — do not import from there.
 */
export const getIsAcceptanceTest = (webdriver = window.navigator.webdriver) => !!webdriver;